// Arbre racine du site, partagé par le navigateur (main.tsx) et le pré-rendu au build
// (entry-prerender.tsx), pour que le HTML pré-rendu corresponde exactement au rendu React.
import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "wouter";
import CookieBanner from "./components/CookieBanner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { HomeDE, HomeEN, HomeNL } from "./pages/LangHome";
import NewHome from "./pages/NewHome";

const AppWithTRPC = lazy(() => import("./AppWithTRPC"));

function HomeShell({ locale }: { locale?: "en" | "de" | "nl" }) {
  const Home = locale === "en" ? HomeEN : locale === "de" ? HomeDE : locale === "nl" ? HomeNL : NewHome;
  useEffect(() => {
    const preloadApp = () => void import("./AppWithTRPC");
    const idleCallback = window.requestIdleCallback?.(preloadApp, { timeout: 5000 });
    const timeoutId = idleCallback === undefined ? window.setTimeout(preloadApp, 5000) : undefined;

    return () => {
      if (idleCallback !== undefined) window.cancelIdleCallback?.(idleCallback);
      if (timeoutId !== undefined) window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <ThemeProvider defaultTheme="light">
      <LanguageProvider initialLang={locale}>
        <Home />
        <CookieBanner />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default function AppEntry() {
  const [location] = useLocation();
  const locale = location === "/en" ? "en" : location === "/de" ? "de" : location === "/nl" ? "nl" : undefined;
  const isHome = location === "/" || Boolean(locale);

  if (isHome) return <HomeShell locale={locale} />;
  return (
    <Suspense fallback={null}>
      <AppWithTRPC />
    </Suspense>
  );
}
